import Box, { IBoxProps } from '../../../Box';

export interface IPanelContentProps extends IBoxProps {}

const PanelContent = (props: IPanelContentProps) => {
  const {
    children, ...rest
  } = props;

  return (
    <Box p={2} {...rest}>
      {children}
    </Box>
  );
};

export default PanelContent;
